<div class="storage-request-page core-screen order-cockpit">
  @if (facade.loading()) {
    <div class="loading">
      <span>{{ 'common.loading' | translate }}</span>
    </div>
  } @else if (facade.errorKind()) {
    <div class="empty-state">
      <div class="empty-state__content">
        <img
          class="empty-state__icon"
          ngSrc="/icons/unboxing.svg"
          alt=""
          width="80"
          height="80"
        />
        <h2 class="empty-state__title">
          {{
            (facade.errorKind() === 'notFound'
              ? 'admin.storageRequests.detailNotFoundTitle'
              : facade.errorKind() === 'accessDenied'
                ? 'admin.storageRequests.detailAccessDeniedTitle'
                : 'admin.storageRequests.detailLoadErrorTitle'
            ) | translate
          }}
        </h2>
        <p class="empty-state__description">
          {{
            (facade.errorKind() === 'notFound'
              ? 'admin.storageRequests.detailNotFoundDescription'
              : facade.errorKind() === 'accessDenied'
                ? 'admin.storageRequests.detailAccessDeniedDescription'
                : 'admin.storageRequests.detailLoadErrorDescription'
            ) | translate
          }}
        </p>
      </div>
    </div>
  } @else if (facade.row()) {
    <div class="order-cockpit__content">
      <section class="order-cockpit__process">
        <lib-staff-order-detail-header />

        <section class="order-cockpit__details">
          @if (facade.row()?.user_id) {
            <article class="order-reference">
              <button
                type="button"
                class="order-reference__toggle"
                [attr.aria-expanded]="facade.referenceLinksExpanded()"
                (click)="facade.toggleReferenceLinksExpanded()"
              >
                <span class="order-reference__title">{{
                  'staff.orders.cockpit.reference.clientLinksTitle' | translate
                }}</span>
                <span
                  class="order-reference__toggle-icon"
                  [class.order-reference__toggle-icon--expanded]="
                    facade.referenceLinksExpanded()
                  "
                  aria-hidden="true"
                ></span>
              </button>

              @if (facade.referenceLinksExpanded()) {
                <div class="order-reference__content">
                  <button
                    type="button"
                    class="order-reference__link"
                    (click)="facade.onOpenClientProfile()"
                  >
                    {{ 'admin.storageRequests.quickActionProfile' | translate }}
                  </button>
                  <button
                    type="button"
                    class="order-reference__link"
                    (click)="facade.onOpenClientItems()"
                  >
                    {{ 'admin.users.openItems' | translate }}
                  </button>
                  <button
                    type="button"
                    class="order-reference__link"
                    (click)="facade.onOpenClientOrders()"
                  >
                    {{ 'admin.users.openOrders' | translate }}
                  </button>
                  <button
                    type="button"
                    class="order-reference__link"
                    [disabled]="facade.printingClientQr()"
                    (click)="facade.printClientQr()"
                  >
                    {{ 'admin.users.printClientQr' | translate }}
                  </button>
                </div>
              }
            </article>
          }

          <lib-staff-order-detail-key-info />
          <lib-staff-order-detail-wallet-card />

          @if (facade.orderPhotosLoading() || facade.orderPhotos().length > 0) {
            <article class="order-reference">
              <button
                type="button"
                class="order-reference__toggle"
                [attr.aria-expanded]="facade.attachmentsExpanded()"
                (click)="facade.toggleAttachmentsExpanded()"
              >
                <span class="order-reference__title">{{
                  'staff.orders.cockpit.reference.attachmentsTitle' | translate
                }}</span>
                <span
                  class="order-reference__toggle-icon"
                  [class.order-reference__toggle-icon--expanded]="
                    facade.attachmentsExpanded()
                  "
                  aria-hidden="true"
                ></span>
              </button>

              @if (facade.attachmentsExpanded()) {
                <div
                  class="order-reference__content order-reference__content--photos"
                >
                  @if (facade.orderPhotosLoading()) {
                    <span class="order-reference__loading">{{
                      'admin.storageRequests.orderPhotosLoading' | translate
                    }}</span>
                  } @else {
                    <div class="order-reference__photos-grid">
                      @for (photo of facade.orderPhotos(); track photo.id) {
                        <a
                          class="order-reference__photo-thumb"
                          [href]="photo.url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img [src]="photo.url" alt="" loading="lazy" />
                        </a>
                      }
                    </div>
                  }
                </div>
              }
            </article>
          }

          @if (facade.timeline().length > 0) {
            <article class="order-reference">
              <button
                type="button"
                class="order-reference__toggle"
                [attr.aria-expanded]="facade.timelineExpanded()"
                (click)="facade.toggleTimelineExpanded()"
              >
                <span class="order-reference__title">{{
                  'staff.orders.cockpit.reference.timelineTitle' | translate
                }}</span>
                <span
                  class="order-reference__toggle-icon"
                  [class.order-reference__toggle-icon--expanded]="
                    facade.timelineExpanded()
                  "
                  aria-hidden="true"
                ></span>
              </button>

              @if (facade.timelineExpanded()) {
                <div class="order-reference__content">
                  <lib-staff-order-detail-timeline />
                </div>
              }
            </article>
          }
        </section>

        <lib-staff-order-detail-next-action />
      </section>

      <section
        id="staff-order-active-workspace"
        class="order-cockpit__workspace"
        tabindex="-1"
      >
        @if (facade.showManagerPanel()) {
          <lib-staff-order-detail-manager-panel />
        }

        @if (facade.showMoverPanel()) {
          <lib-staff-order-detail-mover-panel />
        }

        @if (facade.showWarehousePanel()) {
          <lib-staff-order-detail-warehouse-panel />
        }
      </section>

      <section class="order-cockpit__details">
        <article class="order-reference">
          <button
            type="button"
            class="order-reference__toggle"
            [attr.aria-expanded]="facade.detailsExpanded()"
            (click)="facade.toggleDetailsExpanded()"
          >
            <span class="order-reference__title">{{
              'staff.orders.cockpit.reference.technicalDetailsTitle' | translate
            }}</span>
            <span
              class="order-reference__toggle-icon"
              [class.order-reference__toggle-icon--expanded]="
                facade.detailsExpanded()
              "
              aria-hidden="true"
            ></span>
          </button>

          @if (facade.detailsExpanded()) {
            <div class="order-reference__content">
              <lib-staff-order-detail-technical-details />
            </div>
          }
        </article>
      </section>
    </div>
  }
</div>
